<template>
  <div id="nodes-management" class="h-full">
    <el-card class="h-full" :body-style="{ height: '100%', padding: '20px' }">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <el-input
            v-model="searchName"
            placeholder="场景名称"
            class="w-200px"
            size="small"
            clearable
          ></el-input>
          <el-select
            v-model="searchStatus"
            placeholder="状态"
            clearable
            size="small"
            class="w-200px ml-10px"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            size="small"
            class="ml-10px"
            @click="searchResult"
            :disabled="!$hasAccess('read')"
            >搜索</el-button
          >
          <el-button size="small" class="ml-10px" @click="resetSearch">重置</el-button>
          <el-button
            type="primary"
            size="small"
            class="ml-10px"
            @click="openOperate('add', '新增', null)"
            :disabled="!$hasAccess('create')"
            >新增</el-button
          >
          <el-button
            type="danger"
            size="small"
            class="ml-10px"
            @click="deleteDatas(selectionIds)"
            :disabled="!$hasAccess('delete')"
            >删除</el-button
          >
        </div>
        <div>
          <el-button
            size="small"
            @click="serverMonitorVisible = true"
            :disabled="!$hasAccess('read')"
            >服务监控</el-button
          >
          <el-button
            size="small"
            class="ml-10px"
            @click="configVisible = true"
            :disabled="!$hasAccess('read')"
            >配置云渲染节点</el-button
          >
        </div>
      </div>
      <div class="table-content mt-20px h-[calc(100%-104px)]" v-loading="listLoading">
        <el-table
          ref="tableList"
          :data="dataList"
          height="100%"
          :stripe="true"
          border
          row-key="id"
          @selection-change="selectionChange"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="selection"
            reserve-selection
            width="55px"
          >
          </el-table-column>
          <el-table-column
            prop="seqNo"
            label="序号"
            header-align="center"
            align="center"
            width="75px"
          >
          </el-table-column>
          <el-table-column prop="sceneName" label="名称" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="preloadedMinNodes" label="预加载最少节点数" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="preloadedMaxNodes" label="预加载最多节点数" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="freeTimeNodes" label="空闲节点" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="isActive" label="状态" show-overflow-tooltip>
            <template #default="{row}">
              <el-switch
                v-model="row.isActive"
                active-color="#13ce66"
                @change="(e) => changeActive(e, row)"
                :disabled="!row.isActive && row.preloadedMinNodes > availableCount"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" show-overflow-tooltip>
            <template #default="{row}">
              <el-button
                size="mini"
                :disabled="!$hasAccess('read')"
                @click="openOperate('detail', '详情', row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                :disabled="!$hasAccess('update')"
                @click="openOperate('edit', '编辑', row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                :disabled="!$hasAccess('delete')"
                @click="deleteDatas([row.id])"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="getDataList"
          @size-change="searchResult"
          class="mt-20px float-right"
          small
          background
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :page-size.sync="pageSize"
          :current-page.sync="pageNo"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        >
        </el-pagination>
      </div>
      <OperateDialog
        v-if="operateConfig.visible"
        :maxConnectCount="maxConnectCount"
        :availableCount="availableCount"
        :config="operateConfig"
        :sceneList="sceneList"
        @close="operateClose"
        @operateSuccess="searchResult"
      ></OperateDialog>
      <ServerMonitor
        v-if="serverMonitorVisible"
        :visible.sync="serverMonitorVisible"
      ></ServerMonitor>
      <el-dialog
        title="配置"
        :visible.sync="configVisible"
        class="mini-dialog"
        @close="configVisible = false"
      >
        <el-form label-width="150px" size="small">
          <el-form-item label="最大节点数">
            <el-input-number
              :value="maxConnectCount"
              controls-position="right"
              disabled
            ></el-input-number>
            <div class="text-12px mt-10px">
              注：根据模型大小和云渲染硬件性能配置最大开启节点个数
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { CloudRenderNodesApi } from '@wiz-api/cloud-render-management'
import { ModelSceneApi } from '@wiz-api/scene-management'
import dayjs from 'dayjs'
import CloudProxyService from '../services/CloudProxyService'

const modelSceneApi = new ModelSceneApi()
const cloudRenderNodesApi = new CloudRenderNodesApi()

const OperateDialog = () => {
  return import('../components/CloudNodeSettings/OperateDialog')
}
const ServerMonitor = () => {
  return import('../components/CloudNodeSettings/ServerMonitor')
}
export default {
  components: { OperateDialog, ServerMonitor },
  data() {
    return {
      configVisible: false,
      operateConfig: {
        visible: false,
        title: '',
        type: '',
        data: null,
      },
      searchName: '',
      searchStatus: '',
      listLoading: false,
      statusList: [
        { value: true, label: '开启' },
        { value: false, label: '关闭' },
      ],
      dataList: [],
      pageSize: 15,
      pageNo: 1,
      pageTotal: 0,
      selectionIds: [],
      sceneList: [],
      availableCount: 0,
      maxConnectCount: 0,
      serverMonitorVisible: false,
    }
  },
  created() {
    this.getMaxNodeCount()
    this.getSceneList()
    this.getDataList()
  },
  methods: {
    // 切换状态
    async changeActive(val, row) {
      const [err, res] = await cloudRenderNodesApi.update(row.id, {
        body: {
          ..._.pick(row, [
            'isActive',
            'seqNo',
            'sceneId',
            'preloadedMinNodes',
            'preloadedMaxNodes',
            'freeTimeNodes',
          ]),
          id: row.id,
        },
      })
      if (!err) {
        this.$message.success('操作成功')
        this.getDataList()
      }
    },
    // 获取最大节点数
    async getMaxNodeCount() {
      const [err, res] = await CloudProxyService.getClusters({
        t: dayjs().valueOf(),
      })
      console.log(res, 11111111)
      if (!err && res) {
        this.maxConnectCount = 0
        let usedEngineCount = 0
        _.forEach(_.values(res), (item) => {
          this.maxConnectCount += item.maxEngineCount
          usedEngineCount += item.usedEngineCount
        })
        this.availableCount = this.maxConnectCount - usedEngineCount
      }
    },
    // 关闭新增、编辑框
    operateClose() {
      this.operateConfig = this.$options.data().operateConfig
    },
    // 打开操作框
    openOperate(type, title, data) {
      this.operateConfig.visible = true
      this.operateConfig.title = title
      this.operateConfig.type = type
      this.operateConfig.data = data
    },
    // 获取场景列表
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        name: '',
        folderId: '',
        maxResultCount: 999,
        skipCount: 0,
      })
      if (!err) {
        this.sceneList = res.items
      }
    },
    // 重置搜索
    resetSearch() {
      this.searchName = ''
      this.searchStatus = ''
      this.searchResult()
    },
    // 表格选中事件
    selectionChange(rows) {
      this.selectionIds = _.map(rows, 'id')
    },
    // 删除数据
    deleteDatas(ids) {
      if (!ids.length) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('是否确认删除所选数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await cloudRenderNodesApi.deleteMany({
          ids,
        })
        if (!err) {
          this.$message.success('删除成功')
          this.searchResult()
          this.selectionIds = []
          this.$refs.tableList.clearSelection()
        }
      })
    },
    // 获取列表数据
    async getDataList() {
      this.listLoading = true
      const [err, res] = await cloudRenderNodesApi.getList_0({
        name: this.searchName,
        isActive: this.searchStatus,
        maxResultCount: this.pageSize,
        skipCount: (this.pageNo - 1) * this.pageSize,
      })
      this.listLoading = false
      if (!err) {
        this.dataList = res.items
        this.pageTotal = res.totalCount
      }
    },
    // 搜索结果
    searchResult() {
      this.pageNo = 1
      this.getDataList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-input-number--small {
  width: 280px !important;
}

::v-deep .el-input.is-disabled .el-input__inner {
  color: #000;
}
</style>
